import { render, staticRenderFns } from "./TransHistory.vue?vue&type=template&id=06b90dc2"
import script from "./TransHistory.vue?vue&type=script&lang=js"
export * from "./TransHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports